import { Time } from '@angular/common';
import { Bike } from './bike';
import { Group } from './group';
import { StationItem } from './station';
import { Contract } from './contract';
import { BikeType } from './bike-type.enum';

export class Trip {

    id: number;
    status: TripStatus;
    kmLength: number;
    tripStartTime: Date;
    tripEndTime: Date;

    usedBikeId: number;
    usedBikeName: string;
    usedBikeType: BikeType;

    startStationId: number;
    startStationName: string;

    endStationId: number;
    endStationName: string;

    contractId: number;
    contractType: string;
    contractGroupId: number;
    contractGroupName: string;
    contractUserId: number;
    contractUserFirstName: string;
    contractUserLastName: string;
    contractUserEmail: string;

    contractSubPlanId: number;
    contractSubPlanName: string;

    duration: number;
    durationToDisplay: string;

    amountCents?: number;
}


export enum TripStatus {
    UNLOCK_CMD_PROVIDED = 'UNLOCK_CMD_PROVIDED',
    ON_THE_WAY = 'ON_THE_WAY',
    TERMINATED = 'TERMINATED',
    ABNORMALLY_TERMINATED = 'ABNORMALLY_TERMINATED'
}



// WEBPACK FOOTER //
// ./src/app/models/trip.ts